import ArchiveContent from '../components/layout/Archive/ArchiveContent';


function ArchivePage() {
  return (
    <section>
      <ArchiveContent />
    </section>
  );
}

export default ArchivePage;